export default __webpack_public_path__ + "static/media/full_screen_listings.554635bc.png";